import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { 
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    TableSortLabel,
    TablePagination
} from '@material-ui/core';
import { Loading } from '../../component/loading';

class TemplateTable extends Component {

// ====================== Inits ====================== //

    constructor() {
        super();
        this.state = {
            edited: [],
            editError: [],
            header: [
                { id: 'contactName', label: 'Business Name', align: 'left', sortable: true },
                { id: 'createOn', label: 'Created On', align: 'left', sortable: false },
                { id: 'modifiedOn', label: 'Modified On', align: 'left', sortable: false },
                { id: 'totalItems', label: 'Total Items', align: 'left', sortable: false },
            ],
            rowsPerPage: 20,
            page: 0,
        };
    }

    // ====================== Functions ====================== //

    handleChangePage = (event, page) => {
        this.setState({
            page
        });
    };

    handleChangeRowsPerPage = (event) => {
        const rowsPerPage = parseInt(event.target.value, 10);
        this.setState({
            rowsPerPage,
            page: 0,
        });
    };
    
    isSelected = (data) => {
        const { selected } = this.props;
        const exist = selected && selected.find(item => item.contactName === data.contactName);
        return exist ? true : false;
    }

    isCheckedAll = () => {
        const { selected, reportData } = this.props;
        return selected && reportData && selected.length === reportData.length ? true : false;
    }


    // ====================== Data Functions ====================== //
     
    // ====================== Firebase Functions ====================== //

    // ====================== Render Component ====================== //

    renderTableHead = () => {
        const { reportData, orderBy, order } = this.props;
        const { header } = this.state;
        const checkAll = this.isCheckedAll();
        const disabled = !(reportData && reportData.length > 0);
        return (
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={checkAll}
                    disabled={disabled}
                    onChange={() => this.props.handleCheckAll()}
                    inputProps={{ 'aria-label': 'select all desserts' }}
                    color='primary'
                  />
                </TableCell>
                { header && header.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding='default'
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        { this.renderTableSortLabel(headCell, disabled)}
                    </TableCell>
                )) }
              </TableRow>
            </TableHead>
        );
    }

    renderTableSortLabel = (headCell, disabled) => {
        const { orderBy, order } = this.props;
        if (headCell.sortable) {
            return (
                <TableSortLabel
                    disabled={disabled}
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={() => this.props.handleSort(headCell.id)}
                >
                    {headCell.label}
                </TableSortLabel>
            );
        } 
        return headCell.label
    }

    renderTableBody = () => {
        const { reportData, loading } = this.props;
        const { rowsPerPage, page } = this.state;
        const length = reportData && reportData.length;
        let data = reportData;
        if (length > 1) {
            data = reportData && reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        }
        if (!loading) {
            return (
                <TableBody>
                    { data && data.map((row, index) => this.renderTableRow({ row, index })) }
                </TableBody>
            );
        }
        return <TableBody />;
    }

    // ====================== Render Table Default ====================== //

    renderTableRow = ({ row, index }) => {
        const { selectedEditContact } = this.props;
        const isItemSelected = this.isSelected(row);
        const labelId = `table-checkbox-${index}`;
        const isEdditingContact = selectedEditContact && row.contactName === selectedEditContact.contactName;
        return (
            <TableRow
                hover
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                key={index}
                selected={isItemSelected}
                onClick={() => this.props.selectedRow(row)}
                className={ isEdditingContact ? 'editting-contact' : '' }
                style={{ cursor: "pointer" }}
            >
                <TableCell align='left' padding='checkbox'>
                    <Checkbox
                        checked={isItemSelected}
                        color='primary'
                        inputProps={{ 'aria-labelledby': labelId }}
                        onChange={() => this.props.handleCheck(row)}
                    />
                </TableCell>
                <TableCell align='left'>{row.contactName}</TableCell>
                <TableCell align='left'>{row.createdOn}</TableCell>
                <TableCell align='left'>{row.modifiedOn}</TableCell>
                <TableCell align='left'>{row.totalItems}</TableCell>
            </TableRow>
        );
    }

    renderTableFooter = () => {
        const { reportData } = this.props;
        const { rowsPerPage, page } = this.state;
        const length = reportData && reportData.length;
        if (length > 1) {
            return (
                <TablePagination
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    component="div"
                    count={length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            );
        }
        return null;
    }
    
    // ====================== Render Modal ====================== //

    // ====================== Render Main ====================== //

    render() {
        const { loading } = this.props;
        return (
            <Paper style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                <TableContainer className='report-table' style={{ flex: 1, maxHeight: 'calc(100vh - 180px)' }}>
                    <Table stickyHeader aria-label="sticky table">
                        { this.renderTableHead() }
                        { this.renderTableBody() }
                    </Table>
                </TableContainer>
                { this.renderTableFooter() }
                <Loading loading={loading} />
            </Paper>
        ); 
    }
}


export default compose(connect(null,null))(TemplateTable)